import React, { useState, useEffect } from 'react';
import mixpanel from 'mixpanel-browser';
import { useDispatch, useSelector } from 'react-redux';

import { AccountBalance as AccountBalanceIcon } from '@mui/icons-material';

import { ModalPopup } from '../../Elements/Modal';

import { AssetWorthModalContent } from './AssetWorthModalContent';
import { ModalButtonContent } from '../ModalButtonContent';

import {
  getUserLiabilityInfo,
  getUserAssetInfo,
  createUserAssetInfo,
  createUserLiabilityInfo,
  updateUserAssetInfo,
} from '../../../actions';

import {
  NET_WORTH_INFO,
  ASSETS_AND_NET_WORTH_INFO,
  NET_WORTH,
  ASSETS,
  LIABILITIES,
} from '../../../constants/Dashboard/Asset-NetWorth';

export const AssetWorth = ({ user, tokenValue }) => {
  const [open, setOpen] = useState(false);
  const [isConfirmed, setIsConfirmed] = useState(false);

  const dispatch = useDispatch();
  const assetsAndNetWorthInfo = useSelector(
    ({ assetsAndNetWorthReducer }) => assetsAndNetWorthReducer,
  );

  useEffect(() => {
    setIsConfirmed(
      !!assetsAndNetWorthInfo[NET_WORTH][ASSETS] ||
        !!assetsAndNetWorthInfo[NET_WORTH][LIABILITIES] ||
        !!assetsAndNetWorthInfo[NET_WORTH][NET_WORTH],
    );
  }, [
    assetsAndNetWorthInfo[NET_WORTH][ASSETS],
    assetsAndNetWorthInfo[NET_WORTH][LIABILITIES],
    assetsAndNetWorthInfo[NET_WORTH][NET_WORTH],
  ]);

  useEffect(() => {
    if (user?.id && tokenValue) {
      dispatch(getUserAssetInfo({ id: user.id, tokenValue }));
      dispatch(getUserLiabilityInfo({ id: user.id, tokenValue }));
    }
  }, [user?.id, tokenValue]);

  const handleOpen = () => {
    setOpen(true);
    mixpanel.track('Dashboard Modal', {
      user_id: user.id,
      distinct_id: user.id,
      Modal: 'Asset Worth',
      action: 'Open',
      confirmed: isConfirmed,
    });
  };
  const handleClose = () => {
    setOpen(false);
    mixpanel.track('Dashboard Modal', {
      user_id: user.id,
      distinct_id: user.id,
      Modal: 'Asset Worth',
      action: 'Close',
      confirmed: isConfirmed,
    });
  };
  const handleConfirm = ({ assetWorthInfo }) => {
    setIsConfirmed(true);

    const { Assets, Liabilities } = assetWorthInfo;

    mixpanel.track('Dashboard Modal', {
      user_id: user?.id,
      Modal: 'Assets and Networth',
      action: 'Confirm',
    });

    dispatch(
      createUserAssetInfo({
        Assets,
        usersId: user.id,
        tokenValue,
      }),
    );

    dispatch(
      createUserLiabilityInfo({
        Liabilities,
        usersId: user.id,
        tokenValue,
      }),
    );

    // console.log('Liability', Liabilities);

    // if (Assets?.id) {
    //   dispatch(
    //     updateUserAssetInfo({
    //       Assets,
    //       usersId: user.id,
    //     }),
    //   );
    // } else {
    //   dispatch(
    //     createUserAssetInfo({
    //       Assets,
    //       usersId: user.id,
    //     }),
    //   );
    // }

    setOpen(false);
  };

  return (
    <div className="dashboard-user-info-row-item">
      <ModalPopup
        buttonContent={
          <ModalButtonContent
            isConfirmed={isConfirmed}
            modalButtonIcon={<AccountBalanceIcon sx={{ mr: 2 }} />}
            modalButtonTitle={NET_WORTH_INFO}
          />
        }
        modalContent={
          <AssetWorthModalContent
            handleClose={handleClose}
            onConfirm={handleConfirm}
            assetsAndNetWorthInfo={assetsAndNetWorthInfo}
            user={user}
          />
        }
        title={ASSETS_AND_NET_WORTH_INFO}
        modalButtonId="net-worth-modal-button"
        handleOpen={handleOpen}
        handleClose={handleClose}
        open={open}
      />
    </div>
  );
};
